var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group"},_vm._l((_vm.data),function(item,index){return _c('Radio',{key:index,staticClass:"mr1x mb1x",class:{disable:item.disabled},attrs:{"label":item.value,"text":item.text},model:{value:(_vm.groupValue),callback:function ($$v) {_vm.groupValue=$$v},expression:"groupValue"}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42936b76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ui/RadioGroup.vue
// module id = null
// module chunks = 